/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import RegulationContent from './components/RegulationContent';


const SectionContainer = styled.div`
  padding: 16px;
  padding-top: 70px;
`;

const Regulation = () => {
  return (
    <>
      <SectionContainer>
        <Typography variant="h6" component="h2" className="bold-text" align="center" style={{ margin: "16px 0 24px" }}>
          Regulamento
        </Typography>
        <RegulationContent />
      </SectionContainer>
    </>
  );
};

export default Regulation;